/**
 * LocalStorage keys used across the app.
 * Centralized so sign-out and components stay in sync.
 */
export const NOTIFICATION_BANNER_CLOSED_KEY = "qualifyme-notification-banner-closed";

/**
 * Layout heights (px) for CSS calc and --banner-height / --header-height.
 * Header = Ant Design Header default; banner = padding + line height.
 */
export const LAYOUT_HEADER_HEIGHT_PX = 64;
export const LAYOUT_BANNER_HEIGHT_PX = 44;
